import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import SubscriptionService from '../services/subscriptionService';
import CircularProgress from './circularProgress';
import {getConfigDeviceAndLocationData} from "../common/configDeviceAndLocationData";

const Confirm = ({ data, subscription, config, channel, channelURL }) => {
    const { t } = useTranslation();
    const [confirmPending, setConfirmPending] = useState(false);
    const [confirmError, setConfirmError] = useState(null);
    const [confirmSuccess, setConfirmSuccess] = useState(false);

    useEffect(() => {
        if (data.token && !confirmPending && !confirmError && !confirmSuccess) {
            setConfirmPending(true);
            getConfigDeviceAndLocationData().then((deviceAndLocationData) => {
                SubscriptionService.confirm(data.token, { ...data, deviceAndLocationData }).then((subscription) => {
                    setConfirmPending(false);
                    setConfirmSuccess(true);
                }).catch((error) => {
                    setConfirmPending(false);
                    setConfirmError(error);
                });
            });
        }
    }, [data, confirmPending, confirmError, confirmSuccess]);

    return (
        <div className="content full-height flex-center flex-orientation-v">
            <div className="organization-logo">
                <img src={config.logo} height="100%" alt={"Logo"} />
            </div>
            <div>
                {confirmPending && <div className="full-width">
                    <CircularProgress />
                </div>}
                {!confirmPending && <p className="mdc-typography mdc-typography--subtitle1 fs-20">
                    <span>
                        {confirmSuccess && <span>{t("home.confirm.success")}</span>}
                        {confirmError && <span>{t("home.confirm.error")}</span>}
                    </span>
                </p>}
            </div>
        </div>
    );
}

export default Confirm;
